/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersbusinessestitle2Inputs */

const en_partnersbusinessestitle2 = /** @type {(inputs: Partnersbusinessestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Came through this partner`)
};

const de_partnersbusinessestitle2 = /** @type {(inputs: Partnersbusinessestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über Partner gekommen`)
};

/**
* | output |
* | --- |
* | "Came through this partner" |
*
* @param {Partnersbusinessestitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersbusinessestitle2 = /** @type {((inputs?: Partnersbusinessestitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersbusinessestitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersbusinessestitle2(inputs)
	return de_partnersbusinessestitle2(inputs)
});
export { partnersbusinessestitle2 as "partnersBusinessesTitle" }